import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="2xl"
    >
      <ModalContent className="p-0 max-h-[80vh] overflow-hidden">
        <ModalHeader className="flex flex-col gap-1 p-6">
          <h2 className="text-xl font-bold">Política de Privacidad</h2>
        </ModalHeader>
        
        <ModalBody className="p-6 overflow-y-auto max-h-[40vh]">
          <div className="space-y-4">
            <section>
              <h3 className="text-lg font-semibold mb-2">1. Información que Recopilamos</h3>
              <p className="text-sm text-gray-600">
                Recopilamos información personal que usted nos proporciona directamente 
                al registrarse en nuestro sitio, al comunicarse con nosotros o al utilizar 
                nuestros servicios. Esto puede incluir nombre, dirección de correo electrónico 
                y otra información de contacto.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">2. Uso de la Información</h3>
              <p className="text-sm text-gray-600">
                Utilizamos la información recopilada para proporcionar y mejorar nuestros 
                servicios, para comunicarnos con usted, para enviarle actualizaciones y 
                para fines de análisis y mejora del sitio web.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">3. Compartir Información</h3>
              <p className="text-sm text-gray-600">
                No vendemos, comerciamos ni alquilamos su información personal a terceros. 
                Podemos compartir información con proveedores de servicios de confianza 
                que nos ayudan a operar nuestro sitio, realizar negocios o atender a nuestros usuarios.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">4. Seguridad de Datos</h3>
              <p className="text-sm text-gray-600">
                Implementamos medidas de seguridad adecuadas para proteger contra el 
                acceso no autorizado, alteración, divulgación o destrucción de su 
                información personal.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">5. Cookies</h3>
              <p className="text-sm text-gray-600">
                Utilizamos cookies para mejorar la experiencia del usuario, comprender 
                mejor cómo se utiliza nuestro sitio y para fines de análisis. 
                Puede configurar su navegador para rechazar todas las cookies o 
                para indicarle cuándo se envía una cookie.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">6. Derechos del Usuario</h3>
              <p className="text-sm text-gray-600">
                Usted tiene derecho a acceder, actualizar o eliminar su información personal. 
                También tiene derecho a oponerse al procesamiento de sus datos personales 
                o solicitar la limitación del procesamiento en ciertas circunstancias.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">7. Cambios a la Política</h3>
              <p className="text-sm text-gray-600">
                Podemos actualizar esta Política de Privacidad ocasionalmente. 
                Le notificaremos cualquier cambio publicando la nueva Política 
                de Privacidad en esta página.
              </p>
            </section>
          </div>
        </ModalBody>
        
        <ModalFooter className="p-6">
          <Button color="primary" variant="light" onClick={onClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PrivacyPolicyModal;